import type {
  CreateExpensePayload,
  CreateExpenseFromMovementPayload,
  ExpenseMovementLinkPayload,
  ExpenseExportFilters,
  ExpenseListFilters,
  UpdateExpensePayload
} from 'washday-sdk';
import WashdayClientSingleton from './WashdayClientSingleton';

export type AdoptCashierBoxMovementVariables =
  | { data: CreateExpenseFromMovementPayload; expenseId?: never }
  | { data: ExpenseMovementLinkPayload; expenseId: string };

export const adoptCashierBoxMovementV2 = async (variables: AdoptCashierBoxMovementVariables) => {
  const client = WashdayClientSingleton.getInstance();
  return variables.expenseId
    ? client.expenses.linkCashierBoxMovement(variables.expenseId, variables.data)
    : client.expenses.createFromMovement(variables.data as CreateExpenseFromMovementPayload);
};

export const getExpensesV2 = async (storeId: string, filters: ExpenseListFilters = {}) => {
  return WashdayClientSingleton.getInstance().expenses.getList(storeId, filters);
};

export const exportExpensesV2 = async (
  storeId: string,
  filters: ExpenseExportFilters = {}
) => {
  return WashdayClientSingleton.getInstance().expenses.exportList(storeId, filters);
};

export const getExpenseByIdV2 = async (expenseId: string, storeId: string) => {
  return WashdayClientSingleton.getInstance().expenses.getById(expenseId, storeId);
};

export const createExpenseV2 = async (data: CreateExpensePayload) => {
  return WashdayClientSingleton.getInstance().expenses.create(data);
};

export const updateExpenseByIdV2 = async (
  expenseId: string,
  storeId: string,
  data: UpdateExpensePayload
) => {
  return WashdayClientSingleton.getInstance().expenses.updateById(expenseId, storeId, data);
};

export const deleteExpenseByIdV2 = async (expenseId: string, storeId: string) => {
  return WashdayClientSingleton.getInstance().expenses.deleteById(expenseId, storeId);
};
